import React, { useEffect, useState } from 'react'
import '../../assets/css/0020_objects/0990_obj_challenge_gain_level_ventes.css'

const ObjChallengeGainLevelVentes = ({ paliers }) => {

	const [animate, setAnimate] = useState(false)

	// Déclenche animation après montage
	useEffect(() => {
		const timer = setTimeout(() => {
			setAnimate(true)
		}, 100) // petit délai pour déclencher transition

		return () => clearTimeout(timer)
	}, [])

	const maxValue = Math.max(...paliers.map(p => p.ChallengePallier_NbUnity))

	return (
		<div className="obj_challenge_gain-level_ventes">
			<div className="ctn_challenge_gain-level_ventes">

				<div className="ctn_title">
					<h4 className="t_title">Un gain à la hauteur de vos ventes</h4>
					<p className="t_desc">Ventes</p>
				</div>

				<div className="ctn_paliers">
					{paliers.map((palier, index) => {
						const widthPercent = (palier.ChallengePallier_NbUnity / maxValue) * 100

						return (
							<div key={index} className="obj_item-palier">
								<div
									className={`obj_palier ${animate ? 'is-animated' : ''}`}
									style={{
										width: animate ? `${widthPercent}%` : '0%',
										transitionDelay: `${index * 0.15}s`
									}}
								>
									<span
										style={{
											transitionDelay: `${index * 0.15 + 0.35}s`
										}}
									>
										{palier.ChallengePallier_NbUnity}
									</span>
								</div>

								<div className="obj_palier-label">
									<strong>
										{palier.ChallengePallier_Gain}
										<sup>€</sup>
									</strong>
								</div>
							</div>
						)
					})}
				</div>

			</div>
		</div>
	)
}

export default ObjChallengeGainLevelVentes